// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"b3b8f2e2","683":"277cda1f","786":"f65bb794"}[chunkId] + ".chunk.js";
};